export default __webpack_public_path__ + "static/media/b&a-woman-desk-first-below.e2d6a6dd.png";